import projectData from 'ProjectData/project.json'
import axios from 'axios'

const state = {
  ui: {
    contactcard: true,
    infopanel: true
  }
}

const getters = {
  getState (state) {
    return state
  }
}

const actions = {
  async fetchData ({ commit }) {
    const response = await axios
      .get(projectData)
    return commit('setState', response.data)
  }
}

const mutations = {
  setState (state, data) {
    state.ui = data.ui
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
